import { useState } from "react";
import { Action } from "./styles";
import { IoMdCheckmark, IoMdCopy } from "react-icons/io";
import { toast } from "react-toastify";

export default function CopyButton({ url }) {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    try {
      setCopied(true);

      toast.success('Link copiado com sucesso');
      await navigator.clipboard.writeText(url);
    } catch(error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setCopied(false);
      }, 800);
    }
  }

  return (
    <Action copied={copied} disabled={copied} onClick={handleCopyClick}>
      {copied ? (
        <>
          <span>Link copiado</span>
          <IoMdCheckmark size="1.25em" />
        </>
      ) : (
        <>
          <span>Copiar Link</span>
          <IoMdCopy size="1.25em" />
        </>
      )}
    </Action>
  )
}